<template>
  <div class="animated fadeIn demo-split">
    <Split v-model="split1">
      <div slot="left" class="demo-split-pane">
        <Row>
          <Select
            size="small"
            style="width: 200px; margin-right: 3px;"
            v-model="selectGroupId"
            filterable
            clearable
            remote
            :remote-method="searchGroup"
            :loading="searchGroupLoading">
            <Option v-for="(option, index) in searchGroupList" :value="option.id" :key="option.id">{{option.name}}</Option>
          </Select>
          <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
          <Button type="primary" size="small" style="margin-right: 3px;" @click="onClear">清空</Button>
          <Button type="primary" size="small" @click="onAddRootUserGroupClick">添加根分组</Button>
        </Row>
        <Row v-if="selectGroupId===null || selectGroupTree === null" :style="{height:(treeHeight + 'px'), overflow:'auto'}">
          <Col span="24">
            <Tree :data="defaultGroupData" :load-data="onLoadChildrenGroupData" style="overflow: hidden;" :render="renderContent"></Tree>
          </Col>
        </Row>
        <Row v-if="selectGroupId!==null && selectGroupTree !== null" :style="{height:(treeHeight + 'px'), overflow:'auto'}">
          <Col span="24">
            <Tree :data="selectGroupTree" :load-data="onLoadChildrenGroupData" style="overflow: hidden;" :render="renderContent"></Tree>
          </Col>
        </Row>
      </div>
      <div slot="right" class="demo-split-pane">
        <Row>当前选择分组:<label style="color: cornflowerblue">{{selectUsersByGroupName}}</label></Row>
        <Row>
          <div style="width: 100%;">
            <div style="position:relative;">
              <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
              <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                     @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
              <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
                <Spin size="large"></Spin>
                <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
              </div>
            </div>
            <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
                  style="text-align:right;margin-top:3px;"></Page>
          </div>
        </Row>
      </div>
    </Split>
    <add-user-group-modal v-model="addUserGroupModal" :parentUserGroupId="addUserGroupParentId" @on-success="onGroupOPSuccess"></add-user-group-modal>
    <user-group-detail-modal v-model="userGroupDetailModal" :initValue="userGroupDetailId" @on-success="onGroupOPSuccess"></user-group-detail-modal>
    <set-role-modal v-model="setRoleModal" :initValue="setRoleUserId"></set-role-modal>
    <user-detail-modal v-model="userDetailModal" :initValue="userDetailId" @on-success="onModifySuccess"></user-detail-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>
<script>
import SetRoleModal from '@/view/acl/components/set-role-modal'
import UserDetailModal from '@/view/acl/components/user-detail-modal'

import AddUserGroupModal from '@/view/acl/components/add-user-group-modal'
import UserGroupDetailModal from '@/view/acl/components/user-group-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

export default {
  // 此名称与routers.js中name一致方可缓存
  name: 'usergroups',
  components: {
    AddUserGroupModal,
    UserGroupDetailModal,
    SetRoleModal,
    UserDetailModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      treeHeight: 400,

      sexFilter: null,
      stateFilter: null,

      // 设置角色
      setRoleModal: false,
      setRoleUserId: null,

      // 用户详细信息
      userDetailModal: false,
      userDetailId: null,

      // 添加用户分组
      addUserGroupModal: false,
      addUserGroupParentId: null,

      // 用户组详细信息
      userGroupDetailModal: false,
      userGroupDetailId: null,

      filterType: [],
      split1: 0.3,
      keywordFilter: null,
      isSearch: false,
      tempChildrenGroups: null,
      searchGroupLoading: false,
      searchGroupList: [],
      selectGroupId: null,
      selectUsersByGroupId: null,
      selectUsersByGroupName: null,
      selectGroupTree: null,
      defaultGroupData: [
        {
          id: 1,
          title: '超级管理员组--《合》',
          expand: false,
          checked: true,
          selected: true,
          loading: false,
          children: []
        }
      ],

      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      pageSize: 0,
      content: [],
      totalElements: 0,
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          minWidth: 100
        },
        {
          title: '用户名',
          resizable: true,
          key: 'name',
          ellipsis: 'true',
          minWidth: 200
        },
        {
          title: '昵称',
          resizable: true,
          key: 'nickName',
          ellipsis: 'true',
          minWidth: 200
        },
        {
          title: '真实姓名',
          resizable: true,
          key: 'realName',
          ellipsis: 'true',
          minWidth: 160
        },
        {
          title: '头像',
          resizable: true,
          key: 'avatarUrl',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            if (params.row.avatarUrl) {
              return h('img',
                {
                  attrs: { src: params.row.avatarUrl },
                  style: { width: '45px', height: '45px' }
                })
            }
          }
        },
        {
          title: '性别',
          resizable: true,
          ellipsis: 'true',
          key: 'sex',
          minWidth: 90,
          filters: [
            { label: '男', value: 1 },
            { label: '女', value: 0 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.sexFilter = genQueryParam('sex', 'EQ', val[0])
            } else {
              this.sexFilter = null
            }
          },
          render: function (h, params) {
            if (params.row.sex === 1) {
              return h('div', '男')
            } else if (params.row.sex === 0) {
              return h('div', '女')
            } else {
              return h('div', '未知')
            }
          }
        },
        {
          title: '电话',
          resizable: true,
          key: 'mobilePhoneNum',
          sortable: 'custom',
          ellipsis: 'true',
          minWidth: 120
        },
        {
          title: '注册时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDate',
          minWidth: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '最后登录时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'lastLoginDatetime',
          minWidth: 180,
          render: function (h, params) {
            if (params.row.lastLoginDatetime) {
              let d = new Date(params.row.lastLoginDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '状态',
          resizable: true,
          tooltip: 'true',
          minWidth: 120,
          filters: [
            { label: '正常', value: 1 },
            { label: '禁用', value: 2 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.stateFilter = genQueryParam('state', 'EQ', val[0])
            } else {
              this.stateFilter = null
            }
          },
          render: (h, params) => {
            const task_status = params.row.state
            if (task_status == 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    color: 'green'
                  }
                }, '正常')
              ])
            } else if (task_status == 2) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    color: 'red'
                  }
                }, '禁用')
              ])
            }
          }
        },

        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 350,
          render: (h, params) => {
            const task_status = params.row.deleted
            if (task_status === false) {
              return h('div', [
                h('strong', {
                  style: {
                    marginRight: '5px'
                  }
                }, '禁用'),
                h('i-switch', {
                  style: {
                    marginRight: '10px'
                  },
                  props: {
                    type: 'primary',
                    value: params.row.state != 1
                  },
                  on: {
                    'on-change': (val) => {
                      let disp = ''
                      let state = 0

                      if (val) {
                        state = 1
                        disp = '<p>确认禁用该用户账号</p>'
                      } else {
                        state = 0
                        disp = '<p>确认解禁该用户账号</p>'
                      }

                      // if (params.row.state == false) {
                      this.$Modal.confirm({
                        title: '确认改变用户状态',
                        content: disp,
                        onOk: () => {
                          store.dispatch('UserServ_Disable', {
                            params: { id: params.row.id, disable: state }
                          }).then(() => {
                            this.$Message.success('修改成功')
                            this.refreshPage(this.pageFilter)
                          }).catch(err => {
                            this.$Message.error(err)
                            this.refreshPage(this.pageFilter)
                          })
                        },
                        onCancel: () => {
                          this.refreshPage(this.pageFilter)
                        }
                      })
                      // }
                    }
                  }
                }, ''
                ),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      console.log('this.setRoleModal = true')
                      this.setRoleUserId = params.row.id
                      this.setRoleModal = true
                    }
                  }
                }, '设置角色'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.onResetPasswordBtnClick(params.row.id)
                    }
                  }
                }, '重置密码'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.userDetailId = params.row.id
                      this.userDetailModal = true
                    }
                  }
                }, '详细信息')
              ])
            } else if (task_status === true) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.onActiveBtnClick(params.row.id)
                    }
                  }
                }, '激活')
              ])
            }
          }// render
        }
      ]// cloumn
    }
  },
  methods: {
    ...mapActions([
      'UserGroupServ_GetRootUserGroups',
      'UserGroupServ_GetChildrenUserGroups',
      'UserGroupServ_SearchByName',
      'UserGroupServ_GetDetail',
      'UserServ_GetPage',
      'UserServ_ResetPassword',
      'UserServ_Disable'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onClear () {
      this.selectGroupId = null
      this.selectGroupTree = null
    },
    onAddRootUserGroupClick () {
      this.addUserGroupParentId = null
      this.addUserGroupModal = true
    },
    onFilterTypeChange () {
      this.refreshPage(this.pageFilter)
    },
    searchGroup (input) {
      this.searchGroupLoading = true
      if (!input || input.length <= 0) {
        this.searchGroupList = []
        this.searchGroupLoading = false
      } else {
        store.dispatch('UserGroupServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchGroupList = store.getters.get_UserGroup_SearchByNameResult ? store.getters.get_UserGroup_SearchByNameResult : []
          this.searchGroupLoading = false
        }).catch(err => {
          this.searchGroupLoading = false
        })
      }
    },
    onFilterClick () {
      if (this.selectGroupId !== null) {
        store.dispatch('UserGroupServ_GetDetail', {
          params: { id: this.selectGroupId },
          urlparams: null
        }).then(() => {
          let result = store.getters.get_UserGroup_GetDetailResult ? store.getters.get_UserGroup_GetDetailResult : []
          this.selectGroupTree = [{
            id: result.id,
            title: result.name,
            expand: false,
            loading: false,
            children: []
          }]
          this.searchGroupLoading = false
        }).catch(err => {
          this.searchGroupLoading = false
        })
        console.log('this.selectGroupId !== null')
      }
    },
    onLoadChildrenGroupData (item, callback) {
      // 加载子区域
      store.dispatch('UserGroupServ_GetChildrenUserGroups', {
        params: { id: item.id },
        urlparams: null
      }).then(() => {
        let tempData = []
        this.tempChildrenGroups = store.getters.get_UserGroup_GetChildrenUserGroupsResult ? store.getters.get_UserGroup_GetChildrenUserGroupsResult : []
        this.tempChildrenGroups.forEach((dtoitem, index) => {
          tempData.push({
            id: dtoitem.id,
            title: dtoitem.name,
            profit: dtoitem.profit,
            expand: false,
            loading: false,
            children: [],
            parent: item
          })
        })
        callback(tempData)
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    renderContent (h, { root, node, data }) {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [
        h('span', [
          h('Icon', {
            props: {
              type: 'ios-paper-outline'
            },
            style: {
              marginRight: '8px'
            }
          }),
          h('span', {
            style: {
              // fontSize:'medium',
              // backgroundColor:'#2db7f5',
              // color:'#ffffff'
            },
            on: {
              click: () => {
                this.selectUsersByGroupName = data.title
                this.selectUsersByGroupId = data.id
                this.setPage(1)
              }
            }
          }, data.title)
        ]),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '5px'
          }
        }, [
          h('Button', {
            props: {
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                this.addUserGroupParentId = data.id
                this.addUserGroupModal = true
              }
            }
          }, '+'),
          h('Button', {
            props: {
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                this.userGroupDetailId = data.id
                this.userGroupDetailModal = true
              }
            }
          }, '#')
        ])
      ])
    },
    onResetPasswordBtnClick (userId) {
      this.$Modal.confirm({
        title: '重置密码',
        content: '<p>是否确认重置此用户密码</p>',
        onOk: () => {
          store.dispatch('UserServ_ResetPassword', { params: { userId: userId } }).then(() => {
            this.$Message.success('重置密码成功')
          }).catch(err => {
            this.$Message.error(err)
          })
        },
        onCancel: () => {
        }
      })
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    filterChange () {
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null

      if (this.selectUsersByGroupId) {
        queryParams.push(genQueryParam('userGroupId', 'EQ', this.selectUsersByGroupId))
      }

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.sexFilter) {
        queryParams.push(this.sexFilter)
      }
      if (this.stateFilter) {
        queryParams.push(this.stateFilter)
      }

      store.dispatch('UserServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        if (store.getters.get_User_GetPageResult) {
          this.totalElements = store.getters.get_User_GetPageResult.totalElements
          this.content = store.getters.get_User_GetPageResult.content
          this.pageSize = store.getters.get_User_GetPageResult.size
        } else {
          this.totalElements = 0
          this.content = []
          this.pageSize = 0
        }
        this.listLoadding = false
      }).catch(err => {
        this.totalElements = 0
        this.content = []
        this.pageSize = 0
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onGroupOPSuccess () {
      this.refreshRootUserGroups()
    },
    refreshRootUserGroups () {
      store.dispatch('UserGroupServ_GetRootUserGroups', {
        params: null,
        urlparams: null
      }).then(() => {
        let tempData = []
        let result = store.getters.get_UserGroup_GetRootUserGroupsResult ? store.getters.get_UserGroup_GetRootUserGroupsResult : []
        result.forEach((dtoitem, index) => {
          tempData.push({
            id: dtoitem.id,
            title: dtoitem.name,
            expand: false,
            loading: false,
            children: [],
            parent: null
          })
        })
        this.defaultGroupData = tempData
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {

  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      this.treeHeight = window.innerHeight - 170
      window.onresize = () => {
        this.treeHeight = window.innerHeight - 170
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.refreshRootUserGroups()
    })
  }
}
</script>
<style>
  .demo-split {
    height: 100%;
    border: 1px solid #dcdee2;
  }

  .demo-split-pane {
    padding: 10px;
  }
</style>
